import { render, staticRenderFns } from "./pagenotfound.vue?vue&type=template&id=2c2970d5&scoped=true&"
import script from "./pagenotfound.vue?vue&type=script&lang=ts&"
export * from "./pagenotfound.vue?vue&type=script&lang=ts&"
import style0 from "./pagenotfound.vue?vue&type=style&index=0&id=2c2970d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2970d5",
  null
  
)

component.options.__file = "pagenotfound.vue"
export default component.exports